import {map, sortBy} from "lodash";
import {CourseTypes} from "@/Lib/Enums";

export function optionsToArray(options, sort = true) {

    options = map(options, (label, value) => {

        if (/^\d*$/.test(value)) {
            value = parseInt(value)
        }

        return ({label, value});
    });

    return sort ? sortBy(options, 'label') : options;
}

export function getCourseType( type ) {
    if ( type ) {
        return CourseTypes[type];
    }
    return CourseTypes[1];
}